import api from '../../../api'
import {
	buildCloseTradeData,
	buildOpenTradeData,
	buildPendingTradeData, updateOpenTradeData
} from '../../../components/Dashboard/DashboardContent/Positions/PositionsTable/Table/positionsHelper'
import { executeResponseError, getNewsArray } from '../../../helpers'
import { setSidebarIsOpen } from '../sidebar/actions'
import { getUser } from '../user/actions'

export const POSITIONS_ALL_GET = 'POSITIONS_ALL_GET'
export const NEWS_GET = 'NEWS_GET'
export const POSITIONS_TAB_SET = 'POSITIONS_TAB_SET'
export const POSITIONS_INFO_SET = 'POSITIONS_INFO_SET'
export const POSITIONS_SEARCH_STRING = 'POSITIONS_SEARCH_STRING'
export const POSITIONS_ALL_SET = 'POSITIONS_ALL_SET'
export const POSITIONS_DEFAULT_SET = 'POSITIONS_DEFAULT_SET'
export const UPDATE_TRADES_DATA = 'UPDATE_TRADES_DATA'
export const POSITIONS_MARGIN_CALL_SENT = 'POSITIONS_MARGIN_CALL_SENT'
export const POSITIONS_FOREX_REFRESH_SET = 'POSITIONS_FOREX_REFRESH_SET'
export const TRADES_TIMERS_SET = 'TRADES_TIMERS_SET'

export const getPositionsData = (userId, accessToken, alert) => {
	return async dispatch => {
		try {
			const res = await api.positions.getPositions(userId, accessToken)
			if (res.data.entities) dispatch(setAllPositions(res.data.entities, alert))
			return res.data.entities
		} catch (e) {
			const error = executeResponseError(e, 'Getting trades error')
			throw new Error(error || '')
		}
	}
}

export const checkMarginCall = (access_token, userId, alert) => {
	return async dispatch => {
		try {
			const res = await api.positions.getMarginCall({access_token, userId})
			if (res) {
				dispatch(getPositionsData(userId, access_token, alert))
				dispatch(getUser(access_token))
			}
			return res.data.entities
		} catch (e) {
			dispatch(getPositionsData(userId, access_token, alert))
		}
	}
}

export const setAllPositions = (allPositions) => {
	return (dispatch, getState) => {
		const marginTrade = getState().appReducer.orders.marginTrade
		const userCurrency = getState().appReducer.user?.userData?.currency
		const tailDigitOfCurrency = (userCurrency === 'BTC' || userCurrency ===  'ETH') ? 8 : 2
		const latestBidAsk = {}
		let totalAmountTradeOpen = 0
		let obj = allPositions.reduce((result, trade) => {
			let key = ''
			let formattedTrade = {}
			if (trade.status === 'open') {
				totalAmountTradeOpen = +totalAmountTradeOpen + +trade.amount
				key = 'open'
				formattedTrade = buildOpenTradeData(trade, latestBidAsk, userCurrency, tailDigitOfCurrency, marginTrade)
			} else if (trade.status.indexOf('pending') >= 0) {
				key = 'pending'
				formattedTrade = buildPendingTradeData(trade)
			}  else if (trade.status !== 'open' &&  trade.status.indexOf('pending') < 0) {
				key = 'close'
				formattedTrade = buildCloseTradeData(trade, userCurrency, tailDigitOfCurrency)
			}
			if (!result.formatted) result.formatted = {}
			if (!result.default) result.default = {}
			if (!result.formatted[key]) result.formatted[key] = {}
			result.formatted[key][trade.id] = formattedTrade
			if (!result.default[key]) result.default[key] = {}
			result.default[key][trade.id] = trade
			return result;
		}, {})
		if(obj && obj.formatted) {
			dispatch({
				payload: {'formatted': obj.formatted, totalAmountTradeOpen},
				type: POSITIONS_ALL_SET
			})
			if (obj.formatted['open']) dispatch(setRefreshOpenTrades(obj.formatted['open']))
		}
		if(obj && obj.default) {
			dispatch({
				payload: obj.default,
				type: POSITIONS_DEFAULT_SET
			})
		}
	}
}

export const setRefreshOpenTrades = (openTrades) => {
	return (dispatch, getState) => {
		const tradesTimers = {...getState().appReducer.positions.tradesTimers}
		// For each new trade received
		Object.keys(openTrades).forEach(( ot ) => {
			let trade = openTrades[ot]
			// Trades to Refresh ASAP
			let endDate = new Date(undefined) //todo were to get
			let now = new Date()
			if(endDate < now) {
				// dispatch(setRefreshTrade(trade.id))
				// trade.status = 'refreshing' // todo if to get endDate
			} else {
				if(!tradesTimers[trade.id]){
					const timer = window.setInterval(function() {
						let timeCounter = null
						if(timeCounter) {
							// let updateTime = countdown(new Date(timeCounter.replace(" ","T"))).toString()
							// jQuery(".timeToExpiry_" + trade.id).html(updateTime)
							// if(((new Date(timeCounter.replace(" ","T"))).getTime()-(new Date()).getTime()) <= 0){
							// 	clearInterval(tradesTimers[trade.id])
							// 	delete tradesTimers[trade.id]
							// 	trade.status = 'refreshing'
							// 	refreshTrade(trade.id)
							// }
						}
					}, 5000)
					dispatch(setTradesTimers({tradeId: trade.id, value: timer}))
				}
			}
		})
	}
}

export const getNewsData = (language, alias) => {
	return async dispatch => {
		try {
			const res = await api.positions.getNews(language, alias)
			if (res.data) {
				dispatch({
					payload: getNewsArray(res.data),
					type: NEWS_GET
				})
			}
			return res.data.entities
		} catch (e) {
			const error = executeResponseError(e, 'Getting news error')
			throw new Error(error || '')
		}
	}
}

export const setPositionsTab = (activeTab) => {
	return {
		payload: activeTab,
		type: POSITIONS_TAB_SET
	}
}
export const setForexRefreshTrades = (value) => {
	return {
		payload: value,
		type: POSITIONS_FOREX_REFRESH_SET
	}
}
export const setTradesTimers = (value) => {
	return {
		payload: value,
		type: TRADES_TIMERS_SET
	}
}

export const setMarginCallSent = (value) => {
	return {
		payload: value,
		type: POSITIONS_MARGIN_CALL_SENT
	}
}

export const setNewDataPositions = (data, alert, t) => {
	return (dispatch, getState ) => {
		let pnlAll = {}
		const positionsAll = {...getState().appReducer.positions.positionsAll}
		const marginTrade = getState().appReducer.user?.userJson?.platform?.margin_trade_platform
		const userCurrency = getState().appReducer.user?.userData?.currency
		const tailDigitOfCurrency = (userCurrency === 'BTC' || userCurrency ===  'ETH') ? 8 : 2
		const forexRefreshTrades = []
		const assetsWithNoPricerData = []
		let key
		for (key in data) {
			let positionsOpen = {...positionsAll['open']}
			let position
			for (position in positionsOpen) {
				if (key === positionsOpen[position].asset_id) {
					let trade = {...positionsOpen[position]}
					let newData = updateOpenTradeData(trade, userCurrency, data[key],
						forexRefreshTrades, userCurrency, tailDigitOfCurrency, marginTrade,
						assetsWithNoPricerData, dispatch, alert, t)
					pnlAll[trade.id] = {pnl: newData.pnl_close}
					let newTrade = {...trade, ...newData}
					positionsAll['open'] = {...positionsAll['open'], [trade.id]: newTrade}
				}
			}
		}
		dispatch({
			payload: positionsAll,
			type: UPDATE_TRADES_DATA
		})
	}
}

export const setPositionIdInfo = (data, assetName, sidebarType) => {
	return async dispatch => {
		dispatch({
			payload: data,
			type: POSITIONS_INFO_SET
		})
		dispatch(setSidebarIsOpen(true, sidebarType, assetName))
	}
}

export const setPositionSearchString = (data) => {
	return {
		payload: data,
		type: POSITIONS_SEARCH_STRING
	}
}
export const setRefreshTrade = (tradeId, alert, t) => {
	return async (dispatch, getState ) => {
		const tradesTimers = {...getState().appReducer.positions.tradesTimers}
		const userId = {...getState().appReducer.user.userData.id}
		const access_token = {...getState().appReducer.user.access_token}
		clearInterval(tradesTimers[tradeId])
		try {
			const data = await api.positions.refreshTrade(tradeId)
			if(!(data.result === undefined) && (data.result === 'open')) {
				dispatch(setForexRefreshTrades({tradeId, value: true}))
				return //Do not refresh the trade if it should not close
			}
			if (data['remove'] && data['remove'] === true) {  //Successful refresh trade
				alert.success(t('Trade Was Closed'), {timeout: 5000})

				// Play Sounds
				// if(playSounds == 1) {
				// 	if(data.result == 'won') {
				// 		soundTradeWon.play()
				// 	} else if(data.result == 'lost') {
				// 		soundTradeLost.play()
				// 	} else if(data.result == 'tie') {
				// 		soundTradeTie.play()
				// 	} else if(data.result == 'failed') {
				// 		soundTradeFailed.play()
				// 	} else if(data.result == 'open') {
				// 	} else if(data.result == 'unrefreshed') {
				// 	}  else {
				// 		soundTradeFailed.play()
				// 	}
				// }

				// hiddenTrades.push(tradeId)// todo?
				dispatch(getPositionsData(userId, access_token, alert)) //refresh user balance
				dispatch(getUser(access_token))
				dispatch(setForexRefreshTrades({tradeId, value: true}))
			} else {
				dispatch(setForexRefreshTrades({tradeId, value: undefined}))
			}
		} catch (e) {
			const error = executeResponseError(e, 'Refresh trades error')
			throw new Error(error || '')
		}
	}
}








